import React from 'react';
import { styled } from '@mui/material';
import { Lightbulb } from '@mui/icons-material';
import { Colors } from 'library';
import { Text } from 'library/ui';

export function HiringPolicyNote() {
    return (
        <Box>
            <Lightbulb sx={{ color: Colors.accent, fontSize: 20, flexShrink: 0, marginTop: '1px' }} />
            <Text size="sm" tone="primary" lineHeight="relaxed">
                <Lead>Hiring Policy:</Lead> After a worker completes 120 hours at your center, you can hire them
                permanently at no cost. Once they&apos;re eligible, use <Lead>Mark hired permanently</Lead> on their row
                below to let us know.
            </Text>
        </Box>
    );
}

const Box = styled('div')({
    padding: '12px 16px',
    backgroundColor: Colors.accentSoft,
    border: `1px solid ${Colors.accent}`,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
});

const Lead = styled('b')({
    fontWeight: 700,
});
